export default __webpack_public_path__ + "static/media/solucao-04.e07a4d9f.webp";